import { Card, Input, Modal, Switch } from 'antd';
import React, { useContext, useState } from 'react'
import QRCode from 'react-qr-code';
import { theme } from 'antd';
import { copy } from 'clipboard';
import { toast } from 'sonner';
import { FaCopy } from 'react-icons/fa6';
import { DataContext } from 'context/DataContext';
import apiUtils from 'utils/apiutils';


function Auth() {

    const [changeOpt, setChangeOtp] = useState("");
    const [twofaDeatil, setTwofaDeatil] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisible1, setIsModalVisible1] = useState(false);
    const { token } = theme.useToken();
    const [current, setCurrent] = useState(0);
    const [copyText, setCopyText] = useState("");

    const { profileData, fetchProfileData } = useContext(DataContext)

    console.log(twofaDeatil,"jfhjhdjfhjd")

    const handleCopyText = (e) => {
        setCopyText(e.target.value);
    };

    const copyToClipboard = () => {
        copy(

            (twofaDeatil?.URI ? twofaDeatil?.URI : "")
        );
        toast.success(
            `You have copied the URI
      ${twofaDeatil?.URI ? twofaDeatil?.URI : ""}
      `
        );
    };

    const next = () => {
        setCurrent(current + 1);
    };
    const prev = () => {
        setCurrent(current - 1);
    };

    const handle2fa = (e) => {
        const value = e.target.value;

        // Only allow numerical input and ensure it's exactly 6 digits
        if (/^\d{0,6}$/.test(value)) {
            setChangeOtp(value);
        }
    };


    const steps = [

        {
            title: 'Scan QR',
            content: <div>
                <div className='leading-none mt-4'>
                    <h2 className="text-2xl text-white font-bold">Activate Two-Factor Authentication</h2>

                    <h1 className='font-semibold text-center text-white'>Scan the QR Code using the Authenticator App</h1>
                    <div className='flex justify-center items-center'>
                        <div className="mb-4 w-full sm:w-2/3 flex justify-center items-center pt-5 px-8 flex-row rounded-3xl gap-4">
                            <Card className="">

                                <QRCode value={twofaDeatil ? twofaDeatil?.URI : ''} renderAs="canvas" />
                            </Card>
                        </div>
                    </div>
                </div>



                <div className="flex items-center justify-between gap-4 w-full px-4 py-2 rounded-2xl border border-dashed border-white/20 bg-white/5 backdrop-blur-md shadow-md transition-all duration-300">
                    <p className="text-sm text-white opacity-80">
                        Click to copy your API key
                    </p>


                    <button
                        onClick={copyToClipboard}
                        className="p-2 rounded-lg hover:bg-white/10 transition-colors duration-200"
                    >
                        <FaCopy className="text-neonPurple w-4 h-4" />
                    </button>

                </div>



            </div>,
        },
        {
            title: 'Enter TOTP',
            content: (
                <div className="px-4 py-6">

                    <div className="flex flex-col gap-2 w-full max-w-md mx-auto">
                    <h2 className="text-2xl text-white font-bold">Activate Two-Factor Authentication</h2>

                        <label
                            htmlFor="totp"
                            className="text-sm text-left font-semibold text-white"
                        >
                            Enter TOTP
                        </label>

                        <Input
                            id="totp"
                            placeholder="Enter your 6-digit TOTP code"
                            value={changeOpt}
                            onChange={handle2fa}
                            maxLength={6}
                            className="w-full rounded-lg border border-gray-700 bg-gray-900 focus:bg-black text-white placeholder-gray-500 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                        />
                    </div>
                </div>

            )
        }

    ];


    const contentStyle = {
        lineHeight: '260px',
        textAlign: 'center',

        backgroundColor: token.colorFillAlter,
        borderRadius: 8,
        border: `1px solid ${token.colorBorder}`,

        marginTop: 16,
    };

    const handleSwitchChange = (checked) => {
       
        if (!checked) {
            setIsModalVisible1(true);
        } else {
            setIsModalVisible(true);
            activeTotp();
        }
    };


    const activeTotp = async () => {
        try {

            const response = await apiUtils.post('/user/activate_totp', {}, { showToast: false });

            if (response) {
                setTwofaDeatil(response)
            }
        } catch (err) {

        }
    };

    const changeTotp = async (value) => {
        try {
            const postdata = {

                enabled: value,
                totp: changeOpt
            }
            const response = await apiUtils.post('/user/change_totp', postdata, { showToast: true });

            if (response) {

                setChangeOtp("")
                setIsModalVisible(false)
                setIsModalVisible1(false)
                fetchProfileData()
            }
        } catch (err) {

        }
    };

    return (
        <>
            <Switch onChange={handleSwitchChange}

                checked={profileData?.Profile?.TOTP_Enabled}

                className={`transition-colors duration-300  ${profileData?.Profile?.TOTP_Enabled ? "bg-primary" : "bg-gray-400"}`} />
            <Modal
                open={isModalVisible}
                footer={false}
                style={contentStyle}
                className="custom-dark-modal "
            >
                {/* <Steps current={current} items={items} /> */}
                <div >{steps[current].content}</div>
                <div
                    className='flex justify-between items-center'
                    style={{
                        marginTop: 24,
                    }}
                >
                    <button
                        onClick={() => {
                            setIsModalVisible(false);
                            setCurrent(0);
                            setChangeOtp("");

                        }}
                        className=" bg-black  text-white py-2 px-4 rounded-lg font-semibold hover:bg-opacity-20 transition-colors"
                    >
                        Cancel
                    </button>
                    {current < steps.length - 1 && (
                        <button type="primary" className='bg-white  px-7 py-2 rounded-2xl text-sm text-black' onClick={() => next()}>
                            Next
                        </button>
                    )}
                    {/* {current > 0 && (
                        <Button
                            style={{
                                margin: '0 8px',
                            }}
                            onClick={() => prev()}
                        >
                            Previous
                        </Button>
                    )} */}

                    {current === steps.length - 1 && (
                        <button
                            className='bg-white px-7 py-2 rounded-2xl text-sm text-black'
                            onClick={() => changeTotp(true)}
                        >
                            <span>Done</span>
                        </button>

                    )}


                </div>
            </Modal >
            <Modal
                // title={<div className='md:text-base text-sm '>Deactivate Two-Factor Authentication</div>}
                open={isModalVisible1}
                onCancel={() => setIsModalVisible1(false)}
                onOk={() => setIsModalVisible1(false)}
                footer={false}
                className="custom-dark-modal"
            >

                <div className='py-4 '>
                    <h2 className="text-2xl text-white font-bold">Deactivate Two-Factor Authentication</h2>
                    <div className="text-start  leading-none flex flex-col items-center justify-center w-full ">
                        <div className=" my-3 w-full ">
                            <input
                                placeholder="Enter TOTP"
                                value={changeOpt}
                                onChange={handle2fa}
                                className="w-full bg-black bg-opacity-20 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-neonPurple focus:border-transparent"
                            />

                        </div>
                    </div>

                    <div className="flex space-x-4">
                        <button
                            onClick={() => changeTotp(false)}
                            className="flex-1 bg-white text-gray-900 py-2 px-4 rounded-lg font-semibold hover:bg-neonPurple transition-colors"
                        >
                            Submit
                        </button>
                        <button
                            onClick={() => {
                                setIsModalVisible1(false);
                                setChangeOtp('');

                            }}
                            className="flex-1 bg-white bg-opacity-10 text-white py-2 px-4 rounded-lg font-semibold hover:bg-opacity-20 transition-colors"
                        >
                            Cancel
                        </button>
                    </div>




                </div>

            </Modal>

        </>
    );
}

export default Auth;